export default __webpack_public_path__ + "static/media/plain-sticker-6.5b594284.png";